import { render, staticRenderFns } from "./transhipdetail.vue?vue&type=template&id=1d373028&scoped=true&"
import script from "./transhipdetail.vue?vue&type=script&lang=js&"
export * from "./transhipdetail.vue?vue&type=script&lang=js&"
import style0 from "./transhipdetail.vue?vue&type=style&index=0&id=1d373028&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d373028",
  null
  
)

export default component.exports